import { Input, OnInit } from '@angular/core';
import { ChangeDetectorRef } from '@angular/core';
import { Component, } from '@angular/core';
import { SegmentationItem, SegmentationModel } from '../../models';
import { BreadcrumbService, CoreService, HttpService } from '../../services';

@Component({
  selector: 'q-segmentation-config',
  templateUrl: './segmentation-config.component.html',
  styleUrls: ['./segmentation-config.component.css']

})
export class SegmentationConfigComponent implements OnInit {

  //#Region VARIABLES GLOBALES
  public idBo: string = '0';
  public idDonnee: string = '0';
  public model: SegmentationModel
  //#endregrion

  //#region DIRECTIVES
  @Input('IdBo') set SetIdBo(value: string) {
    this.idBo = value;
  }
  @Input('IdDonnee') set SetIdDonnee(value: string) {
    this.idDonnee = value;
  }
  //#endregrion

  //#region CONSTRUCTOR
  constructor(
    private http: HttpService,
    public indParam: CoreService,
    private cd: ChangeDetectorRef,
    private breadcrumbService: BreadcrumbService,
  ) { }
  //#endregrion

  //#region CYCLE DE VIE
  public ngOnInit(): void {
    this.indParam.showSplash(true);
    const path: string = `${this.indParam.AppParams.apiUrl}api/segmentation/getData/INIT_CONFIG/${this.idBo}|${this.idDonnee}`;
    this.http.getHttp<SegmentationModel>(path).subscribe((result: SegmentationModel) => {
      this.indParam.showSplash(false);
      this.model = result;
      this.model.Items.forEach((item: SegmentationItem) => {
        this.http.getHttp<SegmentationModel>(`${this.indParam.AppParams.apiUrl}api/segmentation/getData/GET_TABLE_COLUMNS/${item.origine}|${item.idRelation}`).subscribe((itemRes: SegmentationModel) => {
          if (itemRes.Items.length == 1 && itemRes.Items[0].tableColumns) {
            const sort: string = item.sort;
            item.sort = '';
            this.cd.detectChanges();
            item.tableColumns = itemRes.Items[0].tableColumns;
            item.sort = sort;
            this.cd.detectChanges();
          }
        });
      })
    });
  }

  public OnSave(): void {
    const model: SegmentationModel = JSON.parse(JSON.stringify(this.model));
    model.IdentBO = this.idBo;
    model.Mode = "SAVE_CONFIG";
    this.indParam.showSplash(true);
    this.http.postHttp<SegmentationModel>(`${this.indParam.AppParams.apiUrl}api/segmentation`, model).subscribe((itemRes: SegmentationModel) => {
      this.indParam.showSplash(false);
      this.breadcrumbService.Back();
    });
  }
  public AllChecked(propName: string): boolean {
    return this.model.Items.filter((item: SegmentationItem) => {
      return !(item as any)[propName]
    }).length == 0
  }

  public OnCheckAll(propName: string): void {
    if (this.AllChecked(propName)) {
      this.model.Items.forEach(item => {
        (item as any)[propName] = false;
      });
    } else {
      this.model.Items.forEach(item => {
        (item as any)[propName] = true;
      })
    }
  }
  public CheckGrille(item: SegmentationItem): void {
    if (item.order) {
      item.isPreview = true;
    }
  }
  public ValueStringified(item: SegmentationItem, propName: string, value: any): void {
    if (value == null || value == undefined || value == '')
      (item as any)[propName] = '';
    else
      (item as any)[propName] = `${value}`;
  }
  //#endregrion

}

